import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import certification1 from '../img/AB-seal-horz.svg.svg';
import googlePartners from '../img/googlePartners.png';
import { homeScroll } from '../smoothScroll';
import indian from '../img/indian.png';
import american from '../img/flag.png';
import aus from '../img/aus_flag.png';
import LogContext from '../context/LogContext';
import metacertificate from  '../img/metacertificate.png';
export default function Footer() {
    const myContext= useContext(LogContext);
    const [currencyType, setCurrencyType] = useState('AUD');
    const setConverterRatio = () => {
        const api = "https://api.exchangerate-api.com/v4/latest/USD";

        function getResults() {
            fetch(`${api}`)
                .then(currency => {
                    return currency.json();
                }).then(currency => {
                    let fromRate = currency.rates['AUD'];
                    let toRate = currency.rates[currencyType];
                    localStorage.setItem('currencyRatio',(toRate / fromRate));
                    myContext.updateCurrency(currencyType,(toRate / fromRate));
                });
        }
        try {
            getResults()
        } catch (error) {
            console.log(error)
        }
       
    }
    useEffect(() => {
        setConverterRatio();
        localStorage.setItem('currencyType', currencyType);
    }, [currencyType])
    return (
        <>
             <div className="container-fluid footer py-5" style={{fontsize:'14px'}}>
            <div className="container py">                
            <div className="row g-5">
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item1 d-flex flex-column">
                            <h4 className="mb-4 text-white">Get In Touch</h4>

                            {window.innerWidth>576 && <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-home me-2" ></i>B-1, Soldier Tower, Commercial <span style={{marginLeft:'27px'}}> Complex, Vikas Puri, New Delhi-<span style={{marginLeft:'27px'}}>India,110018</span></span></Link>}
                            {window.innerWidth> 576 && <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-home me-2"></i>7611 W Thomas Rd, Phoenix, AZ <span style={{marginLeft:'27px'}}>85033, United States</span></Link>}
                            {window.innerWidth> 576 && <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-home me-2"></i>Level 13, Suite 1302/109 Pitt St, <span style={{marginLeft:'27px'}}>Sydney NSW 2000, Australia</span></Link>}

                            {window.innerWidth < 576 && <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-home me-2" ></i>B-1, Soldier Tower, Commercial <span style={{marginLeft:'2px'}}> Complex, Vikas Puri, New Delhi-<span style={{marginLeft:'2px'}}>India,110018</span></span></Link>}
                            {window.innerWidth < 576 && <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-home me-2"></i>7611 W Thomas Rd, Phoenix, AZ <span style={{marginLeft:'2px'}}>85033, United States</span></Link>}

                            {/* <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-envelope me-2"></i> sales@jdtechnicalsolution.com</Link> */}
                            <Link href="" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-envelope me-2"></i> support@jdtechnicalsolution.com</Link>
                            <a href="tel:+91 9971979794" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-phone me-2"></i>India <img className='flags' src={indian} alt="" /><span className='phone-number'>+91 9971979794</span></a>
                            <a href="tel:+1-844-590-3512" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-phone me-2"></i>USA: <img className='flags'src={american} alt="" /><span className='phone-number'>+1-844-590-3512</span></a>
                            <a href="tel:+1800-040-956" style={{textDecorationLine:'none',fontSize:'14px'}}><i className="fas fa-phone me-2"></i>AUS: <img className='flags'src={aus} alt="" /><span className='phone-number'>+1-800-040-956</span></a>

                            <div className="mt-3">
                                <h5 className="text-white mb-2">Working Hours</h5>
                                <p className="mb-1 text-white" style={{ fontSize: '14px' }}>
                                    <i className="fas fa-clock me-2"></i>
                                    Mon - Fri: 10:00 AM to 5:00 PM 
                                </p>
                            </div>

                            <div className="mt-5 d-flex align-items-center">
                                <i className="fas fa-share fa-2x text-white me-2"></i>
                                <Link  to="https://wa.me/qr/HIJ6WMUCWSAQO1">
                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 48 48">
                                    <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"/>
                                    <path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"/>
                                    <path fill="#fff" fillRule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clipRule="evenodd"/>
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <h4 className="mb-4 text-white">Company</h4>
                            <div onClick={()=>{homeScroll('about')}}><Link to="/"><i className="fas fa-angle-right me-2"></i> About</Link></div>
                            <div onClick={()=>{homeScroll('plan')}}><Link to="/websiteDevelopment"><i className="fas fa-angle-right me-2"></i> Plan</Link></div>
                            <div onClick={()=>{homeScroll('testimonial')}}><Link to="/"><i className="fas fa-angle-right me-2"></i> Testimonial</Link></div>
                            <div ><Link to="/hire"><i className="fas fa-angle-right me-2"></i> Hire A Developer</Link></div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item d-flex flex-column">
                            <h4 className="mb-4 text-white">Support</h4>
                            <div onClick={()=>{homeScroll('form')}}><Link to="/contact"><i className="fas fa-angle-right me-2"></i> Contact</Link></div>
                            <div onClick={()=>{homeScroll('navbar')}} ><Link to="/SLA"><i className="fas fa-angle-right me-2"></i> SLA</Link></div>
                            <div onClick={()=>{homeScroll('navbar')}}><Link to="/privacyPolicy"><i className="fas fa-angle-right me-2"></i> Privacy Policy</Link></div>
                            <div onClick={()=>{homeScroll('navbar')}}><Link to="/t&c"><i className="fas fa-angle-right me-2"></i> Terms and Conditions</Link></div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-6 col-xl-3">
                        <div className="footer-item">
                            <div className="row gy-3 gx-2 mb-4">
                                <div className="col-xl-6">
                                    <form>
                                        <div className="form-floating">
                                            <select className="form-select bg-dark border" id="select1">
                                                <option value="1">English</option>
                                            </select>
                                            <label htmlFor="select1">English</label>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-xl-6">
                                    <form>
                                        <div className="form-floating">
                                            <select className="form-select bg-dark border text-light" id="select1" onChange={(e) => setCurrencyType(e.target.value)}>
                                                <option className='text-light' value="AUD">AUD</option>
                                                <option className='text-light' value="USD">USD</option>
                                                <option className='text-light' value="INR">INR</option>
                                                <option className='text-light' value="EUR">EUR</option>
                                                <option className='text-light' value="GBP">GBP</option>
                                                
                                            </select>
                                            <label className='' htmlFor="select1">
                                                {currencyType==='INR' && '₹'}
                                                {currencyType==='USD' && '$'}
                                                {currencyType==='EUR' && '€'}
                                                {currencyType==='GBP' && '€'}
                                                {currencyType === 'AUD' && 'A$'}
                                            </label>


                                        </div>
                                    </form>
                                </div>
                            </div>
                            <h4 className="text-white mb-3">Payments</h4>
                            <div className="footer-bank-card">
                                <Link to="/" className="text-white me-2"><i className="fab fa-cc-amex fa-2x"></i></Link>
                                <Link to="/" className="text-white me-2"><i className="fab fa-cc-visa fa-2x"></i></Link>
                                <Link to="/" className="text-white me-2"><i className="fas fa-credit-card fa-2x"></i></Link>
                                <Link to="/" className="text-white me-2"><i className="fab fa-cc-mastercard fa-2x"></i></Link>
                                <Link to="/" className="text-white me-2"><i className="fab fa-cc-paypal fa-2x"></i></Link>
                                <Link to="/" className="text-white"><i className="fab fa-cc-discover fa-2x"></i></Link>
                            </div>
                            <div className='footer-bank-card my-3'>
                            <img className=' social-links ms-3' src={certification1} alt="certification1" style={{ width: '30%' }} />
                            <img src={googlePartners} alt="googlePartners"  className="p-2" style={{ width: '30%' }} />
                            <img src={metacertificate} alt="metacertificate" style={{ width: '20%' }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container-fluid p-0 copyright text-body">
            <div className="container p-0 mt-0">
                <div className="row g-4 align-items-center mt-0 p-0">
                    <div className="col text-center mt-0 text-white mb-md-0 p-0">
                        <span className='text-white'>Copyright </span><i className="fas fa-copyright text-white me-2"></i>2025 | All Rights Reserved.
                    </div>
                </div>
            </div>
        </div>

        </>
    )
}
